import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToggleTextComponent } from './toggle-text.component';
import { I18nModule } from '@spartacus/core';

@NgModule({
  declarations: [ToggleTextComponent],
  imports: [CommonModule, I18nModule],
  exports: [ToggleTextComponent],
})
export class ToggleTextModule {}
